var _style, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatasetDiagram({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 347 133",
    style: {
      enableBackground: "new 0 0 347 133"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#262262;fill-opacity:0.1;}\n\t.st1{enable-background:new    ;}\n\t.st2{fill:#262262;}\n\t.st3{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st5{mask:url(#mask-2_1_);fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st6{filter:url(#Adobe_OpacityMaskFilter_1_);}\n\t.st7{mask:url(#mask-2_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#262262;}\n\t.st8{filter:url(#Adobe_OpacityMaskFilter_2_);}\n\t.st9{mask:url(#mask-4_1_);fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st10{filter:url(#Adobe_OpacityMaskFilter_3_);}\n\t.st11{mask:url(#mask-4_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#262262;}\n\t.st12{filter:url(#Adobe_OpacityMaskFilter_4_);}\n\t.st13{mask:url(#mask-6_1_);fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st14{filter:url(#Adobe_OpacityMaskFilter_5_);}\n\t.st15{mask:url(#mask-6_2_);fill-rule:evenodd;clip-rule:evenodd;fill:#262262;}\n\t.st16{fill-rule:evenodd;clip-rule:evenodd;fill:#262262;fill-opacity:0.15;}\n\t.st17{opacity:0.75;fill:#216FB4;enable-background:new    ;}\n\t.st18{fill:#FFFFFF;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "DATA-TAB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DATA-TAB-v3",
    transform: "translate(-522.000000, -270.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(522.000000, 267.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    className: "st0",
    d: "M85.2,30.4H3.8c-2.1,0-3.8-1.7-3.8-3.8V13.2c0-2.1,1.7-3.8,3.8-3.8h81.3 c2.1,0,3.8,1.7,3.8,3.8v13.4C89,28.7,87.3,30.4,85.2,30.4z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.6,19.4c0,1.2-0.9,1.9-2.3,1.9h-1.1v1.5h-1.2v-5.4h2.3C24.7,17.4,25.6,18.2,25.6,19.4z M24.3,19.4 c0-0.6-0.4-0.9-1.1-0.9h-1v1.9h1C23.9,20.3,24.3,19.9,24.3,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30,20.4v2.3h-1.1v-0.5c-0.2,0.4-0.6,0.6-1.3,0.6c-1,0-1.5-0.5-1.5-1.2c0-0.7,0.5-1.2,1.8-1.2h0.9 c0-0.5-0.3-0.8-0.9-0.8c-0.4,0-0.9,0.1-1.2,0.4l-0.4-0.8c0.5-0.3,1.1-0.5,1.8-0.5C29.2,18.6,30,19.2,30,20.4z M28.8,21.5V21 H28c-0.6,0-0.7,0.2-0.7,0.5c0,0.3,0.3,0.5,0.7,0.5C28.3,22,28.6,21.8,28.8,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.6,18.6v1.1c-0.1,0-0.2,0-0.3,0c-0.7,0-1.1,0.4-1.1,1.1v1.9H31v-4.1h1.1v0.5 C32.5,18.8,33,18.6,33.6,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.1,22.6c-0.2,0.2-0.6,0.3-1,0.3c-1,0-1.5-0.5-1.5-1.5v-1.7H34v-0.9h0.6v-1h1.2v1h1v0.9h-1v1.7 c0,0.4,0.2,0.5,0.5,0.5c0.2,0,0.4-0.1,0.5-0.2L37.1,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.6,17.4c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.6c0,0.4-0.3,0.7-0.7,0.7S37.6,17.8,37.6,17.4z  M37.8,18.7H39v4.1h-1.2V18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.8,20.7c0-1.2,1-2.1,2.3-2.1c0.9,0,1.5,0.4,1.8,1L43,20.1c-0.2-0.4-0.6-0.6-0.9-0.6 c-0.6,0-1.1,0.4-1.1,1.1s0.5,1.1,1.1,1.1c0.4,0,0.7-0.2,0.9-0.6l0.9,0.5c-0.3,0.7-1,1-1.8,1C40.7,22.8,39.8,21.9,39.8,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.5,17.4c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.6c0,0.4-0.3,0.7-0.7,0.7S44.5,17.8,44.5,17.4z  M44.6,18.7h1.2v4.1h-1.2V18.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.4,20.7c0,1.3-0.9,2.1-2,2.1c-0.5,0-0.9-0.2-1.2-0.5v1.9h-1.2v-5.6H48v0.5c0.3-0.4,0.7-0.5,1.3-0.5 C50.5,18.6,51.4,19.4,51.4,20.7z M50.2,20.7c0-0.7-0.5-1.1-1-1.1s-1,0.4-1,1.1s0.5,1.1,1,1.1S50.2,21.4,50.2,20.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.8,20.4v2.3h-1.1v-0.5c-0.2,0.4-0.6,0.6-1.3,0.6c-1,0-1.5-0.5-1.5-1.2c0-0.7,0.5-1.2,1.8-1.2h0.9 c0-0.5-0.3-0.8-0.9-0.8c-0.4,0-0.9,0.1-1.2,0.4L52,19.1c0.5-0.3,1.1-0.5,1.8-0.5C55,18.6,55.8,19.2,55.8,20.4z M54.6,21.5V21 h-0.8c-0.6,0-0.7,0.2-0.7,0.5c0,0.3,0.3,0.5,0.7,0.5C54.1,22,54.4,21.8,54.6,21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61,20.4v2.4h-1.2v-2.2c0-0.7-0.3-1-0.8-1c-0.6,0-1,0.4-1,1.1v2h-1.2v-4.1H58v0.5 c0.3-0.4,0.8-0.5,1.4-0.5C60.3,18.6,61,19.2,61,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.8,22.6c-0.2,0.2-0.6,0.3-1,0.3c-1,0-1.5-0.5-1.5-1.5v-1.7h-0.6v-0.9h0.6v-1h1.2v1h1v0.9h-1v1.7 c0,0.4,0.2,0.5,0.5,0.5c0.2,0,0.4-0.1,0.5-0.2L64.8,22.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.7,17.4h1.2v5.4h-1.2V17.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.2,17.4h2.4c1.8,0,3,1.1,3,2.7c0,1.6-1.2,2.7-3,2.7h-2.4V17.4z M72.6,21.7c1.1,0,1.8-0.6,1.8-1.7 s-0.7-1.7-1.8-1.7h-1.1v3.3H72.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M80.4,17.4v5.4h-1.2v-4.4h-1.1v-1H80.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(2.898000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 1.4,
    y: 4.3,
    width: 11.6,
    height: 27.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1.4,
    y: 4.3,
    width: 11.6,
    height: 27.5,
    id: "mask-2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_1_",
    className: "st4",
    points: "0,0 14.2,0 14.2,34.5 0,34.5  "
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st5",
    d: "M7.2,4.3c1.4,0,2.6,1.1,2.6,2.5c0,1.4-1.1,2.5-2.6,2.5S4.7,8.2,4.7,6.8 C4.7,5.5,5.8,4.3,7.2,4.3 M4.7,9.4h1.5c0.3,0.1,0.7,0.2,1,0.2c0.4,0,0.7-0.1,1-0.2h1.5c1.8,0,3.3,1.4,3.3,3.2V18 c0,1.3-0.8,2.5-2,3l-0.4,8.3c-0.1,1.4-1.1,2.6-2.5,2.6H7.5v-9.5c0-0.1-0.1-0.3-0.3-0.3S7,22.2,7,22.4v9.5l-0.6,0 c-1.4,0-2.4-1.2-2.5-2.6L3.5,21c-1.2-0.5-2-1.6-2-3v-5.4C1.4,10.8,2.9,9.4,4.7,9.4"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_1_",
    filterUnits: "userSpaceOnUse",
    x: 1.4,
    y: 4.3,
    width: 11.6,
    height: 27.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1.4,
    y: 4.3,
    width: 11.6,
    height: 27.5,
    id: "mask-2_2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1_2_",
    className: "st4",
    points: "0,0 14.2,0 14.2,34.5 0,34.5  "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M7.2,4.3c1.4,0,2.6,1.1,2.6,2.5c0,1.4-1.1,2.5-2.6,2.5S4.7,8.2,4.7,6.8C4.7,5.5,5.8,4.3,7.2,4.3 M4.7,9.4 h1.5c0.3,0.1,0.7,0.2,1,0.2c0.4,0,0.7-0.1,1-0.2h1.5c1.8,0,3.3,1.4,3.3,3.2V18c0,1.3-0.8,2.5-2,3l-0.4,8.3 c-0.1,1.4-1.1,2.6-2.5,2.6H7.5v-9.5c0-0.1-0.1-0.3-0.3-0.3S7,22.2,7,22.4v9.5l-0.6,0c-1.4,0-2.4-1.2-2.5-2.6L3.5,21 c-1.2-0.5-2-1.6-2-3v-5.4C1.4,10.8,2.9,9.4,4.7,9.4"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.2,30.4H3.8c-2.1,0-3.8-1.7-3.8-3.8V13.2c0-2.1,1.7-3.8,3.8-3.8h81.3c2.1,0,3.8,1.7,3.8,3.8v13.4 C89,28.7,87.3,30.4,85.2,30.4z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.6,20.4c0,1.2-0.9,1.9-2.3,1.9h-1.1v1.5h-1.2v-5.4h2.3C24.7,18.4,25.6,19.2,25.6,20.4z M24.3,20.4 c0-0.6-0.4-0.9-1.1-0.9h-1v1.9h1C23.9,21.3,24.3,20.9,24.3,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30,21.4v2.3h-1.1v-0.5c-0.2,0.4-0.6,0.6-1.3,0.6c-1,0-1.5-0.5-1.5-1.2c0-0.7,0.5-1.2,1.8-1.2h0.9 c0-0.5-0.3-0.8-0.9-0.8c-0.4,0-0.9,0.1-1.2,0.4l-0.4-0.8c0.5-0.3,1.1-0.5,1.8-0.5C29.2,19.6,30,20.2,30,21.4z M28.8,22.5V22 H28c-0.6,0-0.7,0.2-0.7,0.5c0,0.3,0.3,0.5,0.7,0.5C28.3,23,28.6,22.8,28.8,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.6,19.6v1.1c-0.1,0-0.2,0-0.3,0c-0.7,0-1.1,0.4-1.1,1.1v1.9H31v-4.1h1.1v0.5 C32.5,19.8,33,19.6,33.6,19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.1,23.6c-0.2,0.2-0.6,0.3-1,0.3c-1,0-1.5-0.5-1.5-1.5v-1.7H34v-0.9h0.6v-1h1.2v1h1v0.9h-1v1.7 c0,0.4,0.2,0.5,0.5,0.5c0.2,0,0.4-0.1,0.5-0.2L37.1,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.6,18.4c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.6c0,0.4-0.3,0.7-0.7,0.7S37.6,18.8,37.6,18.4z  M37.8,19.7H39v4.1h-1.2V19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.8,21.7c0-1.2,1-2.1,2.3-2.1c0.9,0,1.5,0.4,1.8,1L43,21.1c-0.2-0.4-0.6-0.6-0.9-0.6 c-0.6,0-1.1,0.4-1.1,1.1s0.5,1.1,1.1,1.1c0.4,0,0.7-0.2,0.9-0.6l0.9,0.5c-0.3,0.7-1,1-1.8,1C40.7,23.8,39.8,22.9,39.8,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.5,18.4c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.6c0,0.4-0.3,0.7-0.7,0.7S44.5,18.8,44.5,18.4z  M44.6,19.7h1.2v4.1h-1.2V19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.4,21.7c0,1.3-0.9,2.1-2,2.1c-0.5,0-0.9-0.2-1.2-0.5v1.9h-1.2v-5.6H48v0.5c0.3-0.4,0.7-0.5,1.3-0.5 C50.5,19.6,51.4,20.4,51.4,21.7z M50.2,21.7c0-0.7-0.5-1.1-1-1.1s-1,0.4-1,1.1s0.5,1.1,1,1.1S50.2,22.4,50.2,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.8,21.4v2.3h-1.1v-0.5c-0.2,0.4-0.6,0.6-1.3,0.6c-1,0-1.5-0.5-1.5-1.2c0-0.7,0.5-1.2,1.8-1.2h0.9 c0-0.5-0.3-0.8-0.9-0.8c-0.4,0-0.9,0.1-1.2,0.4L52,20.1c0.5-0.3,1.1-0.5,1.8-0.5C55,19.6,55.8,20.2,55.8,21.4z M54.6,22.5V22 h-0.8c-0.6,0-0.7,0.2-0.7,0.5c0,0.3,0.3,0.5,0.7,0.5C54.1,23,54.4,22.8,54.6,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61,21.4v2.4h-1.2v-2.2c0-0.7-0.3-1-0.8-1c-0.6,0-1,0.4-1,1.1v2h-1.2v-4.1H58v0.5 c0.3-0.4,0.8-0.5,1.4-0.5C60.3,19.6,61,20.2,61,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.8,23.6c-0.2,0.2-0.6,0.3-1,0.3c-1,0-1.5-0.5-1.5-1.5v-1.7h-0.6v-0.9h0.6v-1h1.2v1h1v0.9h-1v1.7 c0,0.4,0.2,0.5,0.5,0.5c0.2,0,0.4-0.1,0.5-0.2L64.8,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.7,18.4h1.2v5.4h-1.2V18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.2,18.4h2.4c1.8,0,3,1.1,3,2.7c0,1.6-1.2,2.7-3,2.7h-2.4V18.4z M72.6,22.7c1.1,0,1.8-0.6,1.8-1.7 s-0.7-1.7-1.8-1.7h-1.1v3.3H72.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.4,22.8v1h-4V23l2.1-1.9c0.5-0.5,0.6-0.7,0.6-1c0-0.4-0.3-0.7-0.9-0.7c-0.5,0-0.8,0.2-1.1,0.5 l-0.9-0.6c0.4-0.6,1.2-1,2.1-1c1.2,0,2,0.6,2,1.6c0,0.5-0.1,1-0.9,1.7l-1.2,1.2H82.4z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.898000, 0.000000)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_2_",
    filterUnits: "userSpaceOnUse",
    x: 1.4,
    y: 4.3,
    width: 11.6,
    height: 27.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1.4,
    y: 4.3,
    width: 11.6,
    height: 27.5,
    id: "mask-4_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-3_1_",
    className: "st4",
    points: "0,0 14.2,0 14.2,34.5 0,34.5  "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M7.2,4.3c1.4,0,2.6,1.1,2.6,2.5c0,1.4-1.1,2.5-2.6,2.5S4.7,8.2,4.7,6.8C4.7,5.5,5.8,4.3,7.2,4.3 M4.7,9.4 h1.5c0.3,0.1,0.7,0.2,1,0.2c0.4,0,0.7-0.1,1-0.2h1.5c1.8,0,3.3,1.4,3.3,3.2V18c0,1.3-0.8,2.5-2,3l-0.4,8.3 c-0.1,1.4-1.1,2.6-2.5,2.6H7.5v-9.5c0-0.1-0.1-0.3-0.3-0.3S7,22.2,7,22.4v9.5l-0.6,0c-1.4,0-2.4-1.2-2.5-2.6L3.5,21 c-1.2-0.5-2-1.6-2-3v-5.4C1.4,10.8,2.9,9.4,4.7,9.4"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_3_",
    filterUnits: "userSpaceOnUse",
    x: 1.4,
    y: 4.3,
    width: 11.6,
    height: 27.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1.4,
    y: 4.3,
    width: 11.6,
    height: 27.5,
    id: "mask-4_2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-3_2_",
    className: "st4",
    points: "0,0 14.2,0 14.2,34.5 0,34.5  "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M7.2,4.3c1.4,0,2.6,1.1,2.6,2.5c0,1.4-1.1,2.5-2.6,2.5S4.7,8.2,4.7,6.8C4.7,5.5,5.8,4.3,7.2,4.3  M4.7,9.4h1.5c0.3,0.1,0.7,0.2,1,0.2c0.4,0,0.7-0.1,1-0.2h1.5c1.8,0,3.3,1.4,3.3,3.2V18c0,1.3-0.8,2.5-2,3l-0.4,8.3 c-0.1,1.4-1.1,2.6-2.5,2.6H7.5v-9.5c0-0.1-0.1-0.3-0.3-0.3S7,22.2,7,22.4v9.5l-0.6,0c-1.4,0-2.4-1.2-2.5-2.6L3.5,21 c-1.2-0.5-2-1.6-2-3v-5.4C1.4,10.8,2.9,9.4,4.7,9.4"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M85.2,30.4H3.8c-2.1,0-3.8-1.7-3.8-3.8V13.2c0-2.1,1.7-3.8,3.8-3.8h81.3c2.1,0,3.8,1.7,3.8,3.8v13.4 C89,28.7,87.3,30.4,85.2,30.4z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.6,20.4c0,1.2-0.9,1.9-2.3,1.9h-1.1v1.5h-1.2v-5.4h2.3C24.7,18.4,25.6,19.2,25.6,20.4z M24.3,20.4 c0-0.6-0.4-0.9-1.1-0.9h-1v1.9h1C23.9,21.3,24.3,20.9,24.3,20.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M30,21.4v2.3h-1.1v-0.5c-0.2,0.4-0.6,0.6-1.3,0.6c-1,0-1.5-0.5-1.5-1.2c0-0.7,0.5-1.2,1.8-1.2h0.9 c0-0.5-0.3-0.8-0.9-0.8c-0.4,0-0.9,0.1-1.2,0.4l-0.4-0.8c0.5-0.3,1.1-0.5,1.8-0.5C29.2,19.6,30,20.2,30,21.4z M28.8,22.5V22 H28c-0.6,0-0.7,0.2-0.7,0.5c0,0.3,0.3,0.5,0.7,0.5C28.3,23,28.6,22.8,28.8,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M33.6,19.6v1.1c-0.1,0-0.2,0-0.3,0c-0.7,0-1.1,0.4-1.1,1.1v1.9H31v-4.1h1.1v0.5 C32.5,19.8,33,19.6,33.6,19.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.1,23.6c-0.2,0.2-0.6,0.3-1,0.3c-1,0-1.5-0.5-1.5-1.5v-1.7H34v-0.9h0.6v-1h1.2v1h1v0.9h-1v1.7 c0,0.4,0.2,0.5,0.5,0.5c0.2,0,0.4-0.1,0.5-0.2L37.1,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M37.6,18.4c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.6c0,0.4-0.3,0.7-0.7,0.7S37.6,18.8,37.6,18.4z  M37.8,19.7H39v4.1h-1.2V19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.8,21.7c0-1.2,1-2.1,2.3-2.1c0.9,0,1.5,0.4,1.8,1L43,21.1c-0.2-0.4-0.6-0.6-0.9-0.6 c-0.6,0-1.1,0.4-1.1,1.1s0.5,1.1,1.1,1.1c0.4,0,0.7-0.2,0.9-0.6l0.9,0.5c-0.3,0.7-1,1-1.8,1C40.7,23.8,39.8,22.9,39.8,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M44.5,18.4c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.6c0,0.4-0.3,0.7-0.7,0.7S44.5,18.8,44.5,18.4z  M44.6,19.7h1.2v4.1h-1.2V19.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.4,21.7c0,1.3-0.9,2.1-2,2.1c-0.5,0-0.9-0.2-1.2-0.5v1.9h-1.2v-5.6H48v0.5c0.3-0.4,0.7-0.5,1.3-0.5 C50.5,19.6,51.4,20.4,51.4,21.7z M50.2,21.7c0-0.7-0.5-1.1-1-1.1s-1,0.4-1,1.1s0.5,1.1,1,1.1S50.2,22.4,50.2,21.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M55.8,21.4v2.3h-1.1v-0.5c-0.2,0.4-0.6,0.6-1.3,0.6c-1,0-1.5-0.5-1.5-1.2c0-0.7,0.5-1.2,1.8-1.2h0.9 c0-0.5-0.3-0.8-0.9-0.8c-0.4,0-0.9,0.1-1.2,0.4L52,20.1c0.5-0.3,1.1-0.5,1.8-0.5C55,19.6,55.8,20.2,55.8,21.4z M54.6,22.5V22 h-0.8c-0.6,0-0.7,0.2-0.7,0.5c0,0.3,0.3,0.5,0.7,0.5C54.1,23,54.4,22.8,54.6,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M61,21.4v2.4h-1.2v-2.2c0-0.7-0.3-1-0.8-1c-0.6,0-1,0.4-1,1.1v2h-1.2v-4.1H58v0.5 c0.3-0.4,0.8-0.5,1.4-0.5C60.3,19.6,61,20.2,61,21.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M64.8,23.6c-0.2,0.2-0.6,0.3-1,0.3c-1,0-1.5-0.5-1.5-1.5v-1.7h-0.6v-0.9h0.6v-1h1.2v1h1v0.9h-1v1.7 c0,0.4,0.2,0.5,0.5,0.5c0.2,0,0.4-0.1,0.5-0.2L64.8,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M67.7,18.4h1.2v5.4h-1.2V18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M70.2,18.4h2.4c1.8,0,3,1.1,3,2.7c0,1.6-1.2,2.7-3,2.7h-2.4V18.4z M72.6,22.7c1.1,0,1.8-0.6,1.8-1.7 s-0.7-1.7-1.8-1.7h-1.1v3.3H72.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M82.3,22.1c0,0.9-0.7,1.7-2.2,1.7c-0.7,0-1.5-0.2-2-0.6l0.5-0.9c0.4,0.3,1,0.5,1.5,0.5c0.6,0,1-0.3,1-0.7 c0-0.4-0.3-0.7-1-0.7h-0.6v-0.8l1.1-1.2h-2.3v-1h3.7v0.8l-1.2,1.4C81.8,20.7,82.3,21.3,82.3,22.1z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.898000, 0.000000)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_4_",
    filterUnits: "userSpaceOnUse",
    x: 1.4,
    y: 4.3,
    width: 11.6,
    height: 27.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1.4,
    y: 4.3,
    width: 11.6,
    height: 27.5,
    id: "mask-6_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-5_1_",
    className: "st4",
    points: "0,0 14.2,0 14.2,34.5 0,34.5  "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M7.2,4.3c1.4,0,2.6,1.1,2.6,2.5c0,1.4-1.1,2.5-2.6,2.5S4.7,8.2,4.7,6.8C4.7,5.5,5.8,4.3,7.2,4.3  M4.7,9.4h1.5c0.3,0.1,0.7,0.2,1,0.2c0.4,0,0.7-0.1,1-0.2h1.5c1.8,0,3.3,1.4,3.3,3.2V18c0,1.3-0.8,2.5-2,3l-0.4,8.3 c-0.1,1.4-1.1,2.6-2.5,2.6H7.5v-9.5c0-0.1-0.1-0.3-0.3-0.3S7,22.2,7,22.4v9.5l-0.6,0c-1.4,0-2.4-1.2-2.5-2.6L3.5,21 c-1.2-0.5-2-1.6-2-3v-5.4C1.4,10.8,2.9,9.4,4.7,9.4"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_5_",
    filterUnits: "userSpaceOnUse",
    x: 1.4,
    y: 4.3,
    width: 11.6,
    height: 27.5
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 1.4,
    y: 4.3,
    width: 11.6,
    height: 27.5,
    id: "mask-6_2_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-5_2_",
    className: "st4",
    points: "0,0 14.2,0 14.2,34.5 0,34.5  "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M7.2,4.3c1.4,0,2.6,1.1,2.6,2.5c0,1.4-1.1,2.5-2.6,2.5S4.7,8.2,4.7,6.8C4.7,5.5,5.8,4.3,7.2,4.3  M4.7,9.4h1.5c0.3,0.1,0.7,0.2,1,0.2c0.4,0,0.7-0.1,1-0.2h1.5c1.8,0,3.3,1.4,3.3,3.2V18c0,1.3-0.8,2.5-2,3l-0.4,8.3 c-0.1,1.4-1.1,2.6-2.5,2.6H7.5v-9.5c0-0.1-0.1-0.3-0.3-0.3S7,22.2,7,22.4v9.5l-0.6,0c-1.4,0-2.4-1.2-2.5-2.6L3.5,21 c-1.2-0.5-2-1.6-2-3v-5.4C1.4,10.8,2.9,9.4,4.7,9.4"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M11,115v3H9.1v-3l-3.3-5.4h2.1l2.2,3.7l2.2-3.7h1.9L11,115z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.8,114.8c0-1.9,1.5-3.3,3.6-3.3c2.1,0,3.5,1.4,3.5,3.3c0,1.9-1.5,3.3-3.5,3.3 C15.3,118.1,13.8,116.7,13.8,114.8z M19,114.8c0-1.1-0.7-1.8-1.6-1.8c-0.9,0-1.7,0.7-1.7,1.8s0.7,1.8,1.7,1.8 C18.3,116.6,19,115.9,19,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M28.6,111.5v6.5h-1.8v-0.8c-0.5,0.6-1.2,0.9-2,0.9c-1.6,0-2.8-0.9-2.8-2.9v-3.6H24v3.4 c0,1.1,0.5,1.6,1.3,1.6c0.9,0,1.5-0.6,1.5-1.7v-3.2H28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M34.4,111.5v1.7c-0.2,0-0.3,0-0.4,0c-1,0-1.7,0.6-1.7,1.8v3h-1.9v-6.5h1.8v0.9 C32.6,111.8,33.4,111.5,34.4,111.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.5,113.8c0-2.5,1.9-4.3,4.6-4.3c1.5,0,2.7,0.5,3.5,1.5l-1.2,1.2c-0.6-0.6-1.3-1-2.1-1 c-1.6,0-2.7,1.1-2.7,2.7c0,1.6,1.1,2.7,2.7,2.7c0.8,0,1.5-0.3,2.1-1l1.2,1.2c-0.8,1-2,1.5-3.5,1.5 C40.5,118.1,38.5,116.3,38.5,113.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M47,114.8c0-1.9,1.5-3.3,3.5-3.3c2.1,0,3.5,1.4,3.5,3.3c0,1.9-1.5,3.3-3.5,3.3 C48.5,118.1,47,116.7,47,114.8z M52.2,114.8c0-1.1-0.7-1.8-1.6-1.8c-0.9,0-1.7,0.7-1.7,1.8s0.7,1.8,1.7,1.8 C51.5,116.6,52.2,115.9,52.2,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62,114.3v3.7h-1.9v-3.4c0-1-0.5-1.5-1.3-1.5c-0.9,0-1.5,0.6-1.5,1.7v3.2h-1.9v-8.9h1.9v3.1 c0.5-0.5,1.2-0.8,2.1-0.8C60.8,111.5,62,112.3,62,114.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M63.2,114.8c0-1.9,1.5-3.3,3.5-3.3s3.5,1.4,3.5,3.3c0,1.9-1.5,3.3-3.5,3.3S63.2,116.7,63.2,114.8z  M68.4,114.8c0-1.1-0.7-1.8-1.6-1.8s-1.7,0.7-1.7,1.8s0.7,1.8,1.7,1.8S68.4,115.9,68.4,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M75.6,111.5v1.7c-0.2,0-0.3,0-0.4,0c-1,0-1.7,0.6-1.7,1.8v3h-1.9v-6.5h1.8v0.9 C73.8,111.8,74.6,111.5,75.6,111.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M81.1,117.7c-0.4,0.3-0.9,0.4-1.5,0.4c-1.5,0-2.4-0.8-2.4-2.3v-2.7h-1v-1.4h1v-1.6H79v1.6h1.6v1.4H79v2.6 c0,0.6,0.3,0.9,0.8,0.9c0.3,0,0.6-0.1,0.8-0.2L81.1,117.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M136.9,109.6h3.8c2.7,0,4.6,1.7,4.6,4.2c0,2.5-1.9,4.2-4.6,4.2h-3.8V109.6z M140.6,116.4 c1.7,0,2.8-1,2.8-2.6c0-1.6-1.1-2.6-2.8-2.6h-1.8v5.2H140.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.4,114.3v3.7h-1.8v-0.8c-0.3,0.6-1,0.9-2,0.9c-1.5,0-2.4-0.8-2.4-2c0-1.1,0.8-1.9,2.8-1.9h1.5 c0-0.8-0.5-1.3-1.5-1.3c-0.7,0-1.4,0.2-1.9,0.6l-0.7-1.3c0.7-0.5,1.8-0.8,2.8-0.8C151.3,111.5,152.4,112.4,152.4,114.3z  M150.5,116v-0.7h-1.3c-0.9,0-1.2,0.3-1.2,0.8c0,0.5,0.4,0.8,1.1,0.8C149.8,116.8,150.3,116.5,150.5,116z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M158.3,117.7c-0.4,0.3-0.9,0.4-1.5,0.4c-1.5,0-2.4-0.8-2.4-2.3v-2.7h-1v-1.4h1v-1.6h1.9v1.6h1.6v1.4h-1.6 v2.6c0,0.6,0.3,0.9,0.8,0.9c0.3,0,0.6-0.1,0.8-0.2L158.3,117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M165,114.3v3.7h-1.8v-0.8c-0.3,0.6-1,0.9-2,0.9c-1.5,0-2.4-0.8-2.4-2c0-1.1,0.8-1.9,2.8-1.9h1.5 c0-0.8-0.5-1.3-1.5-1.3c-0.7,0-1.4,0.2-1.9,0.6l-0.7-1.3c0.7-0.5,1.8-0.8,2.8-0.8C163.9,111.5,165,112.4,165,114.3z M163.2,116 v-0.7h-1.3c-0.9,0-1.2,0.3-1.2,0.8c0,0.5,0.4,0.8,1.1,0.8C162.4,116.8,163,116.5,163.2,116z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M175.8,116.2h-3.9l-0.7,1.8h-2l3.7-8.4h1.9l3.8,8.4h-2L175.8,116.2z M175.2,114.7l-1.3-3.2l-1.3,3.2H175.2 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M186.4,114.8c0,2-1.4,3.3-3.2,3.3c-0.9,0-1.6-0.3-2-0.8v0.7h-1.8v-8.9h1.9v3.1c0.5-0.5,1.1-0.8,1.9-0.8 C184.9,111.5,186.4,112.7,186.4,114.8z M184.5,114.8c0-1.1-0.7-1.8-1.6-1.8s-1.6,0.7-1.6,1.8s0.7,1.8,1.6,1.8 S184.5,115.9,184.5,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.1,114.8c0-1.9,1.5-3.3,3.5-3.3s3.5,1.4,3.5,3.3c0,1.9-1.5,3.3-3.5,3.3S187.1,116.7,187.1,114.8z  M192.3,114.8c0-1.1-0.7-1.8-1.6-1.8s-1.7,0.7-1.7,1.8s0.7,1.8,1.7,1.8S192.3,115.9,192.3,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M202,111.5v6.5h-1.8v-0.8c-0.5,0.6-1.2,0.9-2,0.9c-1.6,0-2.8-0.9-2.8-2.9v-3.6h1.9v3.4 c0,1.1,0.5,1.6,1.3,1.6c0.9,0,1.5-0.6,1.5-1.7v-3.2H202z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M207.9,117.7c-0.4,0.3-0.9,0.4-1.5,0.4c-1.5,0-2.4-0.8-2.4-2.3v-2.7h-1v-1.4h1v-1.6h1.9v1.6h1.6v1.4h-1.6 v2.6c0,0.6,0.3,0.9,0.8,0.9c0.3,0,0.6-0.1,0.8-0.2L207.9,117.7z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M139,131.5v3h-1.9v-3l-3.3-5.4h2.1l2.2,3.7l2.2-3.7h1.9L139,131.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M141.8,131.3c0-1.9,1.5-3.3,3.6-3.3c2.1,0,3.5,1.4,3.5,3.3c0,1.9-1.5,3.3-3.5,3.3 C143.3,134.6,141.8,133.2,141.8,131.3z M147,131.3c0-1.1-0.7-1.8-1.6-1.8c-0.9,0-1.7,0.7-1.7,1.8s0.7,1.8,1.7,1.8 C146.3,133.1,147,132.4,147,131.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M156.6,128v6.5h-1.8v-0.8c-0.5,0.6-1.2,0.9-2,0.9c-1.6,0-2.8-0.9-2.8-2.9V128h1.9v3.4 c0,1.1,0.5,1.6,1.3,1.6c0.9,0,1.5-0.6,1.5-1.7V128H156.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M162.4,128v1.7c-0.2,0-0.3,0-0.4,0c-1,0-1.7,0.6-1.7,1.8v3h-1.9V128h1.8v0.9 C160.6,128.3,161.4,128,162.4,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M166.5,130.3c0-2.5,1.9-4.3,4.6-4.3c1.5,0,2.7,0.5,3.5,1.5l-1.2,1.2c-0.6-0.6-1.3-1-2.1-1 c-1.6,0-2.7,1.1-2.7,2.7c0,1.6,1.1,2.7,2.7,2.7c0.8,0,1.5-0.3,2.1-1l1.2,1.2c-0.8,1-2,1.5-3.5,1.5 C168.5,134.6,166.5,132.8,166.5,130.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M175,131.3c0-1.9,1.5-3.3,3.5-3.3c2.1,0,3.5,1.4,3.5,3.3c0,1.9-1.5,3.3-3.5,3.3 C176.5,134.6,175,133.2,175,131.3z M180.2,131.3c0-1.1-0.7-1.8-1.6-1.8c-0.9,0-1.7,0.7-1.7,1.8s0.7,1.8,1.7,1.8 C179.5,133.1,180.2,132.4,180.2,131.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M190,130.8v3.7h-1.9v-3.4c0-1-0.5-1.5-1.3-1.5c-0.9,0-1.5,0.6-1.5,1.7v3.2h-1.9v-8.9h1.9v3.1 c0.5-0.5,1.2-0.8,2.1-0.8C188.8,128,190,128.8,190,130.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M191.2,131.3c0-1.9,1.5-3.3,3.5-3.3s3.5,1.4,3.5,3.3c0,1.9-1.5,3.3-3.5,3.3S191.2,133.2,191.2,131.3z  M196.4,131.3c0-1.1-0.7-1.8-1.6-1.8s-1.7,0.7-1.7,1.8s0.7,1.8,1.7,1.8S196.4,132.4,196.4,131.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M203.6,128v1.7c-0.2,0-0.3,0-0.4,0c-1,0-1.7,0.6-1.7,1.8v3h-1.9V128h1.8v0.9 C201.8,128.3,202.6,128,203.6,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M209.1,134.2c-0.4,0.3-0.9,0.4-1.5,0.4c-1.5,0-2.4-0.8-2.4-2.3v-2.7h-1v-1.4h1v-1.6h1.9v1.6h1.6v1.4H207 v2.6c0,0.6,0.3,0.9,0.8,0.9c0.3,0,0.6-0.1,0.8-0.2L209.1,134.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M264.1,115v3h-1.9v-3l-3.3-5.4h2.1l2.2,3.7l2.2-3.7h1.9L264.1,115z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M266.8,114.8c0-1.9,1.5-3.3,3.5-3.3s3.5,1.4,3.5,3.3c0,1.9-1.5,3.3-3.5,3.3S266.8,116.7,266.8,114.8z  M272,114.8c0-1.1-0.7-1.8-1.6-1.8s-1.7,0.7-1.7,1.8s0.7,1.8,1.7,1.8S272,115.9,272,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M281.7,111.5v6.5h-1.8v-0.8c-0.5,0.6-1.2,0.9-2,0.9c-1.6,0-2.8-0.9-2.8-2.9v-3.6h1.9v3.4 c0,1.1,0.5,1.6,1.3,1.6c0.9,0,1.5-0.6,1.5-1.7v-3.2H281.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M287.4,111.5v1.7c-0.2,0-0.3,0-0.4,0c-1,0-1.7,0.6-1.7,1.8v3h-1.9v-6.5h1.8v0.9 C285.7,111.8,286.4,111.5,287.4,111.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M292.1,109.6h3.8c2.7,0,4.6,1.7,4.6,4.2c0,2.5-1.9,4.2-4.6,4.2h-3.8V109.6z M295.8,116.4 c1.7,0,2.8-1,2.8-2.6c0-1.6-1.1-2.6-2.8-2.6h-1.8v5.2H295.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M307.6,114.3v3.7h-1.8v-0.8c-0.3,0.6-1,0.9-2,0.9c-1.5,0-2.4-0.8-2.4-2c0-1.1,0.8-1.9,2.8-1.9h1.5 c0-0.8-0.5-1.3-1.5-1.3c-0.7,0-1.4,0.2-1.9,0.6l-0.7-1.3c0.7-0.5,1.8-0.8,2.8-0.8C306.5,111.5,307.6,112.4,307.6,114.3z  M305.7,116v-0.7h-1.3c-0.9,0-1.2,0.3-1.2,0.8c0,0.5,0.4,0.8,1.1,0.8C305,116.8,305.5,116.5,305.7,116z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M313.5,117.7c-0.4,0.3-0.9,0.4-1.5,0.4c-1.5,0-2.4-0.8-2.4-2.3v-2.7h-1v-1.4h1v-1.6h1.9v1.6h1.6v1.4h-1.6 v2.6c0,0.6,0.3,0.9,0.8,0.9c0.3,0,0.6-0.1,0.8-0.2L313.5,117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M320.2,114.3v3.7h-1.8v-0.8c-0.3,0.6-1,0.9-2,0.9c-1.5,0-2.4-0.8-2.4-2c0-1.1,0.8-1.9,2.8-1.9h1.5 c0-0.8-0.5-1.3-1.5-1.3c-0.7,0-1.4,0.2-1.9,0.6l-0.7-1.3c0.7-0.5,1.8-0.8,2.8-0.8C319.1,111.5,320.2,112.4,320.2,114.3z  M318.4,116v-0.7h-1.3c-0.9,0-1.2,0.3-1.2,0.8c0,0.5,0.4,0.8,1.1,0.8C317.6,116.8,318.1,116.5,318.4,116z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M321.3,117.4l0.6-1.3c0.6,0.4,1.5,0.6,2.2,0.6c0.9,0,1.2-0.2,1.2-0.6c0-1.1-3.9,0-3.9-2.6 c0-1.2,1.1-2.1,3-2.1c0.9,0,1.9,0.2,2.5,0.6l-0.6,1.3c-0.6-0.4-1.3-0.5-1.9-0.5c-0.8,0-1.2,0.3-1.2,0.6c0,1.1,3.9,0,3.9,2.6 c0,1.2-1.1,2.1-3,2.1C323,118.1,321.9,117.8,321.3,117.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M334.6,115.3h-4.9c0.2,0.8,0.9,1.3,1.8,1.3c0.7,0,1.2-0.2,1.6-0.6l1,1.1c-0.6,0.7-1.5,1-2.7,1 c-2.2,0-3.7-1.4-3.7-3.3c0-1.9,1.5-3.3,3.4-3.3c1.9,0,3.4,1.3,3.4,3.3C334.6,114.9,334.6,115.1,334.6,115.3z M329.7,114.2h3.2 c-0.1-0.8-0.7-1.3-1.6-1.3C330.4,112.9,329.8,113.4,329.7,114.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M340,117.7c-0.4,0.3-0.9,0.4-1.5,0.4c-1.5,0-2.4-0.8-2.4-2.3v-2.7h-1v-1.4h1v-1.6h1.9v1.6h1.6v1.4H338v2.6 c0,0.6,0.3,0.9,0.8,0.9c0.3,0,0.6-0.1,0.8-0.2L340,117.7z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(127.000000, 19.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.4,21.6H3.8c-2.1,0-3.8-1.7-3.8-3.8V4.4c0-2.1,1.7-3.8,3.8-3.8h78.6c2.1,0,3.8,1.7,3.8,3.8v13.4 C86.2,19.9,84.5,21.6,82.4,21.6z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M39.3,13.9l0-3.2l-1.6,2.6h-0.6l-1.6-2.6v3.1h-1.2V8.6h1l2,3.3l2-3.3h1l0,5.4H39.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M45.7,12.2h-3.1c0.1,0.5,0.6,0.8,1.2,0.8c0.4,0,0.7-0.1,1-0.4l0.6,0.7c-0.4,0.4-1,0.7-1.7,0.7 c-1.4,0-2.3-0.9-2.3-2.1c0-1.2,0.9-2.1,2.2-2.1c1.2,0,2.1,0.8,2.1,2.1C45.7,12,45.7,12.1,45.7,12.2z M42.5,11.5h2 c-0.1-0.5-0.5-0.9-1-0.9C43,10.6,42.6,11,42.5,11.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.7,8.2v5.7h-1.1v-0.5c-0.3,0.4-0.7,0.5-1.3,0.5c-1.2,0-2.1-0.8-2.1-2.1s0.9-2.1,2.1-2.1 c0.5,0,0.9,0.2,1.2,0.5v-2H50.7z M49.5,11.9c0-0.7-0.5-1.1-1-1.1c-0.6,0-1.1,0.4-1.1,1.1s0.5,1.1,1.1,1.1 C49.1,13,49.5,12.6,49.5,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.6,8.6c0-0.4,0.3-0.7,0.7-0.7s0.7,0.3,0.7,0.6c0,0.4-0.3,0.7-0.7,0.7S51.6,8.9,51.6,8.6z M51.8,9.8H53 v4.1h-1.2V9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M53.8,11.9c0-1.2,1-2.1,2.3-2.1c0.9,0,1.5,0.4,1.8,1L57,11.3c-0.2-0.4-0.6-0.6-0.9-0.6 c-0.6,0-1.1,0.4-1.1,1.1s0.5,1.1,1.1,1.1c0.4,0,0.7-0.2,0.9-0.6l0.9,0.5c-0.3,0.7-1,1-1.8,1C54.7,14,53.8,13.1,53.8,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.3,11.6v2.3h-1.1v-0.5c-0.2,0.4-0.7,0.6-1.3,0.6c-1,0-1.5-0.5-1.5-1.2c0-0.7,0.5-1.2,1.8-1.2h0.9 c0-0.5-0.3-0.8-0.9-0.8c-0.4,0-0.9,0.1-1.2,0.4l-0.4-0.8c0.5-0.3,1.1-0.5,1.8-0.5C61.5,9.7,62.3,10.3,62.3,11.6z M61.1,12.6 v-0.4h-0.8c-0.6,0-0.7,0.2-0.7,0.5c0,0.3,0.3,0.5,0.7,0.5C60.6,13.2,60.9,13,61.1,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66,13.7c-0.2,0.2-0.6,0.3-1,0.3c-1,0-1.5-0.5-1.5-1.5v-1.7h-0.6V9.9h0.6v-1h1.2v1h1v0.9h-1v1.7 c0,0.4,0.2,0.5,0.5,0.5c0.2,0,0.4-0.1,0.5-0.2L66,13.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66.5,8.6c0-0.4,0.3-0.7,0.7-0.7S68,8.2,68,8.5c0,0.4-0.3,0.7-0.7,0.7S66.5,8.9,66.5,8.6z M66.7,9.8h1.2 v4.1h-1.2V9.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.7,11.9c0-1.2,1-2.1,2.3-2.1c1.3,0,2.3,0.9,2.3,2.1S72.2,14,70.9,14C69.6,14,68.7,13.1,68.7,11.9z  M72,11.9c0-0.7-0.5-1.1-1-1.1c-0.6,0-1.1,0.4-1.1,1.1s0.5,1.1,1.1,1.1C71.5,13,72,12.6,72,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.2,11.6v2.4H77v-2.2c0-0.7-0.3-1-0.8-1c-0.6,0-1,0.4-1,1.1v2H74V9.8h1.1v0.5c0.3-0.4,0.8-0.5,1.4-0.5 C77.4,9.7,78.2,10.3,78.2,11.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(127.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M82.4,21.6H3.8c-2.1,0-3.8-1.7-3.8-3.8V4.4c0-2.1,1.7-3.8,3.8-3.8h78.6c2.1,0,3.8,1.7,3.8,3.8v13.4 C86.2,19.9,84.5,21.6,82.4,21.6z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M57.8,8.6H59v4.3h2.7v1h-3.9V8.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M66,11.6v2.3h-1.1v-0.5c-0.2,0.4-0.7,0.6-1.3,0.6c-1,0-1.5-0.5-1.5-1.2c0-0.7,0.5-1.2,1.8-1.2h0.9 c0-0.5-0.3-0.8-0.9-0.8c-0.4,0-0.9,0.1-1.2,0.4l-0.4-0.8c0.5-0.3,1.1-0.5,1.8-0.5C65.3,9.7,66,10.3,66,11.6z M64.8,12.6v-0.4 H64c-0.6,0-0.7,0.2-0.7,0.5c0,0.3,0.3,0.5,0.7,0.5C64.3,13.2,64.7,13,64.8,12.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M71.6,11.9c0,1.3-0.9,2.1-2,2.1c-0.5,0-1-0.2-1.3-0.5v0.5h-1.1V8.2h1.2v2c0.3-0.3,0.7-0.5,1.2-0.5 C70.7,9.7,71.6,10.6,71.6,11.9z M70.4,11.9c0-0.7-0.5-1.1-1-1.1c-0.6,0-1,0.4-1,1.1s0.5,1.1,1,1.1 C69.9,13,70.4,12.6,70.4,11.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72,13.5l0.4-0.9c0.4,0.2,0.9,0.4,1.4,0.4c0.6,0,0.8-0.1,0.8-0.4c0-0.7-2.5,0-2.5-1.6 c0-0.8,0.7-1.3,1.9-1.3c0.6,0,1.2,0.1,1.6,0.4l-0.4,0.8c-0.4-0.2-0.8-0.3-1.2-0.3c-0.5,0-0.8,0.2-0.8,0.4c0,0.7,2.5,0,2.5,1.6 c0,0.8-0.7,1.3-1.9,1.3C73.1,14,72.4,13.8,72,13.5z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-4",
    className: "st16",
    points: "347,92 251,92 251,66 347,66  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-9",
    className: "st16",
    points: "347,63 251,63 251,33 347,33  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-8",
    className: "st16",
    points: "347,30 251,30 251,4 347,4  "
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M256.6,14.1h1.1V19h-1.1V14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M258.9,14.1h2.2c1.6,0,2.7,1,2.7,2.5c0,1.5-1.1,2.5-2.7,2.5h-2.2V14.1z M261,18.1c1,0,1.6-0.6,1.6-1.5 S262,15,261,15h-1v3H261z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M268.2,14.1V19h-1.1v-4h-1v-0.9H268.2z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M255.6,45.1h1.1V50h-1.1V45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M257.9,45.1h2.2c1.6,0,2.7,1,2.7,2.5c0,1.5-1.1,2.5-2.7,2.5h-2.2V45.1z M260,49.1c1,0,1.6-0.6,1.6-1.5 S261,46,260,46h-1v3H260z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M269,49.1V50h-3.7v-0.7l1.9-1.8c0.4-0.4,0.5-0.7,0.5-0.9c0-0.4-0.3-0.6-0.8-0.6c-0.4,0-0.8,0.2-1,0.5 l-0.8-0.5c0.4-0.6,1.1-0.9,1.9-0.9c1.1,0,1.8,0.6,1.8,1.4c0,0.5-0.1,0.9-0.8,1.5l-1.1,1.1H269z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M255.6,76.1h1.1V81h-1.1V76.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M257.9,76.1h2.2c1.6,0,2.7,1,2.7,2.5c0,1.5-1.1,2.5-2.7,2.5h-2.2V76.1z M260,80.1c1,0,1.6-0.6,1.6-1.5 S261,77,260,77h-1v3H260z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M269,79.5c0,0.8-0.6,1.6-2,1.6c-0.7,0-1.4-0.2-1.9-0.5l0.4-0.9c0.4,0.3,0.9,0.4,1.4,0.4 c0.6,0,0.9-0.2,0.9-0.6c0-0.4-0.3-0.6-0.9-0.6h-0.5v-0.7l1-1.1h-2.1v-0.9h3.4v0.7l-1.1,1.3C268.5,78.2,269,78.8,269,79.5z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "346.5,3.5 346.5,91.5 315.5,91.5 315.5,3.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "312.5,3.5 312.5,91.5 281.5,91.5 281.5,3.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M112.4,47.3c0.3,0,0.6,0.3,0.6,0.6v1.2c0,0.3-0.3,0.6-0.6,0.6h-5.6v5.6c0,0.3-0.3,0.6-0.6,0.6h-1.2 c-0.3,0-0.6-0.3-0.6-0.6v-5.6h-5.6c-0.3,0-0.6-0.3-0.6-0.6v-1.2c0-0.3,0.3-0.6,0.6-0.6h5.6v-5.6c0-0.3,0.3-0.6,0.6-0.6h1.2 c0.3,0,0.6,0.3,0.6,0.6v5.6H112.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M237.4,50.4c0.3,0,0.6,0.3,0.6,0.6v1.2c0,0.3-0.3,0.6-0.6,0.6h-13.7c-0.3,0-0.6-0.3-0.6-0.6V51 c0-0.3,0.3-0.6,0.6-0.6H237.4z M237.4,44.1c0.3,0,0.6,0.3,0.6,0.6V46c0,0.3-0.3,0.6-0.6,0.6h-13.7c-0.3,0-0.6-0.3-0.6-0.6v-1.2 c0-0.3,0.3-0.6,0.6-0.6H237.4z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-22",
    transform: "translate(124.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    className: "st18",
    cx: 15.2,
    cy: 15.2,
    r: 15.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-4",
    className: "st2",
    cx: 15.2,
    cy: 15.2,
    r: 15.2
  })), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M6.8,8.5c-0.1,0-0.3-0.1-0.3-0.3V6.6c0-0.1,0.1-0.3,0.3-0.3h7.1c0.1,0,0.3,0.1,0.3,0.3v1.6 c0,0.1-0.1,0.3-0.3,0.3H13v8.2c0,1.5-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7V8.5H6.8z M9.2,8.5v3.3h2.2V8.5H9.2z M25.5,21.5 c0.3,0,0.5,0.2,0.5,0.5v1.1c0,0.3-0.2,0.5-0.5,0.5H4.9c-0.3,0-0.5-0.2-0.5-0.5v-1.1c0-0.3,0.2-0.5,0.5-0.5H25.5z M16.6,8.5 c-0.1,0-0.3-0.1-0.3-0.3V6.6c0-0.1,0.1-0.3,0.3-0.3h7.1c0.1,0,0.3,0.1,0.3,0.3v1.6c0,0.1-0.1,0.3-0.3,0.3h-0.8v8.2 c0,1.5-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7V8.5H16.6z M19,8.5v3.3h2.2V8.5H19z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-23",
    transform: "translate(124.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st18",
    cx: 15.2,
    cy: 15.2,
    r: 15.2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-5",
    className: "st2",
    cx: 15.2,
    cy: 15.2,
    r: 15.2
  })), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M18.9,18.3l2.7,2.7c0.2,0.2,0.2,0.6,0,0.8l-0.8,0.8c-0.2,0.2-0.6,0.2-0.8,0l-2.7-2.7l-2.7,2.7 c-0.2,0.2-0.6,0.2-0.8,0l-0.8-0.8c-0.2-0.2-0.2-0.6,0-0.8l2.7-2.7l-4.3-4.3h-0.6v2.7c0,0.3-0.2,0.5-0.5,0.5H9.2 c-0.3,0-0.5-0.2-0.5-0.5V7.9c0-0.3,0.2-0.5,0.5-0.5h4.9c1.8,0,3.3,1.5,3.3,3.3c0,1.7-1.2,3-2.9,3.2l2.9,2.9l2.7-2.7 c0.2-0.2,0.6-0.2,0.8,0l0.8,0.8c0.2,0.2,0.2,0.6,0,0.8L18.9,18.3z M10.9,9.6v2.2h3.3c0.6,0,1.1-0.5,1.1-1.1 c0-0.6-0.5-1.1-1.1-1.1H10.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M293,19l0-2.9l-1.4,2.4h-0.5l-1.4-2.4V19h-1.1v-4.9h0.9l1.8,3l1.8-3h0.9l0,4.9H293z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M298.9,17.4H296c0.1,0.5,0.5,0.8,1.1,0.8c0.4,0,0.7-0.1,0.9-0.4l0.6,0.6c-0.4,0.4-0.9,0.6-1.6,0.6 c-1.3,0-2.2-0.8-2.2-1.9c0-1.1,0.9-1.9,2-1.9c1.1,0,2,0.7,2,2C298.9,17.2,298.9,17.3,298.9,17.4z M296,16.8h1.9 c-0.1-0.5-0.4-0.8-0.9-0.8C296.4,16,296.1,16.3,296,16.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M303.4,13.8V19h-1v-0.4c-0.3,0.3-0.7,0.5-1.2,0.5c-1.1,0-1.9-0.8-1.9-1.9s0.8-1.9,1.9-1.9 c0.5,0,0.9,0.1,1.1,0.5v-1.8H303.4z M302.4,17.1c0-0.7-0.4-1-1-1c-0.5,0-1,0.4-1,1s0.4,1,1,1C302,18.2,302.4,17.8,302.4,17.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M308.1,14.1V19H307v-4h-1v-0.9H308.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M292,50l0-2.9l-1.4,2.4h-0.5l-1.4-2.4V50h-1.1v-4.9h0.9l1.8,3l1.8-3h0.9l0,4.9H292z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.9,48.4H295c0.1,0.5,0.5,0.8,1.1,0.8c0.4,0,0.7-0.1,0.9-0.4l0.6,0.6c-0.4,0.4-0.9,0.6-1.6,0.6 c-1.3,0-2.2-0.8-2.2-1.9c0-1.1,0.9-1.9,2-1.9c1.1,0,2,0.7,2,2C297.9,48.2,297.9,48.3,297.9,48.4z M295,47.8h1.9 c-0.1-0.5-0.4-0.8-0.9-0.8C295.4,47,295.1,47.3,295,47.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M302.4,44.8V50h-1v-0.4c-0.3,0.3-0.7,0.5-1.2,0.5c-1.1,0-1.9-0.8-1.9-1.9s0.8-1.9,1.9-1.9 c0.5,0,0.9,0.1,1.1,0.5v-1.8H302.4z M301.4,48.1c0-0.7-0.4-1-1-1c-0.5,0-1,0.4-1,1s0.4,1,1,1C301,49.2,301.4,48.8,301.4,48.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M308.9,49.1V50h-3.7v-0.7l1.9-1.8c0.4-0.4,0.5-0.7,0.5-0.9c0-0.4-0.3-0.6-0.8-0.6c-0.4,0-0.8,0.2-1,0.5 l-0.8-0.5c0.4-0.6,1.1-0.9,1.9-0.9c1.1,0,1.8,0.6,1.8,1.4c0,0.5-0.1,0.9-0.8,1.5l-1.1,1.1H308.9z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M292,81l0-2.9l-1.4,2.4h-0.5l-1.4-2.4V81h-1.1v-4.9h0.9l1.8,3l1.8-3h0.9l0,4.9H292z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M297.9,79.4H295c0.1,0.5,0.5,0.8,1.1,0.8c0.4,0,0.7-0.1,0.9-0.4l0.6,0.6c-0.4,0.4-0.9,0.6-1.6,0.6 c-1.3,0-2.2-0.8-2.2-1.9c0-1.1,0.9-1.9,2-1.9c1.1,0,2,0.7,2,2C297.9,79.2,297.9,79.3,297.9,79.4z M295,78.8h1.9 c-0.1-0.5-0.4-0.8-0.9-0.8C295.4,78,295.1,78.3,295,78.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M302.4,75.8V81h-1v-0.4c-0.3,0.3-0.7,0.5-1.2,0.5c-1.1,0-1.9-0.8-1.9-1.9s0.8-1.9,1.9-1.9 c0.5,0,0.9,0.1,1.1,0.5v-1.8H302.4z M301.4,79.1c0-0.7-0.4-1-1-1c-0.5,0-1,0.4-1,1s0.4,1,1,1C301,80.2,301.4,79.8,301.4,79.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M308.8,79.5c0,0.8-0.6,1.6-2,1.6c-0.7,0-1.4-0.2-1.9-0.5l0.4-0.9c0.4,0.3,0.9,0.4,1.4,0.4 c0.6,0,0.9-0.2,0.9-0.6c0-0.4-0.3-0.6-0.9-0.6h-0.5v-0.7l1-1.1h-2.1v-0.9h3.4v0.7l-1.1,1.3C308.4,78.2,308.8,78.8,308.8,79.5z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M321.6,14.1h1.1v4h2.5V19h-3.6V14.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M329.1,16.8V19h-1v-0.5c-0.2,0.3-0.6,0.5-1.1,0.5c-0.9,0-1.4-0.5-1.4-1.1c0-0.7,0.5-1.1,1.6-1.1h0.9 c0-0.5-0.3-0.7-0.9-0.7c-0.4,0-0.8,0.1-1.1,0.4l-0.4-0.8c0.4-0.3,1-0.5,1.6-0.5C328.4,15.2,329.1,15.7,329.1,16.8z M328,17.8 v-0.4h-0.8c-0.5,0-0.7,0.2-0.7,0.4c0,0.3,0.2,0.5,0.6,0.5C327.6,18.3,327.9,18.2,328,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M334.2,17.1c0,1.2-0.8,1.9-1.9,1.9c-0.5,0-0.9-0.2-1.2-0.5V19h-1v-5.2h1.1v1.8c0.3-0.3,0.7-0.5,1.1-0.5 C333.4,15.2,334.2,15.9,334.2,17.1z M333.1,17.1c0-0.7-0.4-1-1-1c-0.5,0-1,0.4-1,1s0.4,1,1,1C332.7,18.2,333.1,17.8,333.1,17.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M334.6,18.6l0.4-0.8c0.3,0.2,0.8,0.4,1.3,0.4c0.5,0,0.7-0.1,0.7-0.3c0-0.6-2.3,0-2.3-1.5 c0-0.7,0.6-1.2,1.7-1.2c0.5,0,1.1,0.1,1.4,0.3l-0.4,0.8c-0.4-0.2-0.7-0.3-1.1-0.3c-0.5,0-0.7,0.2-0.7,0.4c0,0.6,2.3,0,2.3,1.5 c0,0.7-0.7,1.2-1.8,1.2C335.6,19.1,334.9,18.9,334.6,18.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M342.3,14.1V19h-1.1v-4h-1v-0.9H342.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M320.6,45.1h1.1v4h2.5V50h-3.6V45.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M328.1,47.8V50h-1v-0.5c-0.2,0.3-0.6,0.5-1.1,0.5c-0.9,0-1.4-0.5-1.4-1.1c0-0.7,0.5-1.1,1.6-1.1h0.9 c0-0.5-0.3-0.7-0.9-0.7c-0.4,0-0.8,0.1-1.1,0.4l-0.4-0.8c0.4-0.3,1-0.5,1.6-0.5C327.4,46.2,328.1,46.7,328.1,47.8z M327,48.8 v-0.4h-0.8c-0.5,0-0.7,0.2-0.7,0.4c0,0.3,0.2,0.5,0.6,0.5C326.6,49.3,326.9,49.2,327,48.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M333.2,48.1c0,1.2-0.8,1.9-1.9,1.9c-0.5,0-0.9-0.2-1.2-0.5V50h-1v-5.2h1.1v1.8c0.3-0.3,0.7-0.5,1.1-0.5 C332.4,46.2,333.2,46.9,333.2,48.1z M332.1,48.1c0-0.7-0.4-1-1-1c-0.5,0-1,0.4-1,1s0.4,1,1,1C331.7,49.2,332.1,48.8,332.1,48.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M333.6,49.6l0.4-0.8c0.3,0.2,0.8,0.4,1.3,0.4c0.5,0,0.7-0.1,0.7-0.3c0-0.6-2.3,0-2.3-1.5 c0-0.7,0.6-1.2,1.7-1.2c0.5,0,1.1,0.1,1.4,0.3l-0.4,0.8c-0.4-0.2-0.7-0.3-1.1-0.3c-0.5,0-0.7,0.2-0.7,0.4c0,0.6,2.3,0,2.3,1.5 c0,0.7-0.7,1.2-1.8,1.2C334.6,50.1,333.9,49.9,333.6,49.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M343.1,49.1V50h-3.7v-0.7l1.9-1.8c0.4-0.4,0.5-0.7,0.5-0.9c0-0.4-0.3-0.6-0.8-0.6c-0.4,0-0.8,0.2-1,0.5 l-0.8-0.5c0.4-0.6,1.1-0.9,1.9-0.9c1.1,0,1.8,0.6,1.8,1.4c0,0.5-0.1,0.9-0.8,1.5l-1.1,1.1H343.1z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M320.6,76.1h1.1v4h2.5V81h-3.6V76.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M328.1,78.8V81h-1v-0.5c-0.2,0.3-0.6,0.5-1.1,0.5c-0.9,0-1.4-0.5-1.4-1.1c0-0.7,0.5-1.1,1.6-1.1h0.9 c0-0.5-0.3-0.7-0.9-0.7c-0.4,0-0.8,0.1-1.1,0.4l-0.4-0.8c0.4-0.3,1-0.5,1.6-0.5C327.4,77.2,328.1,77.7,328.1,78.8z M327,79.8 v-0.4h-0.8c-0.5,0-0.7,0.2-0.7,0.4c0,0.3,0.2,0.5,0.6,0.5C326.6,80.3,326.9,80.2,327,79.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M333.2,79.1c0,1.2-0.8,1.9-1.9,1.9c-0.5,0-0.9-0.2-1.2-0.5V81h-1v-5.2h1.1v1.8c0.3-0.3,0.7-0.5,1.1-0.5 C332.4,77.2,333.2,77.9,333.2,79.1z M332.1,79.1c0-0.7-0.4-1-1-1c-0.5,0-1,0.4-1,1s0.4,1,1,1C331.7,80.2,332.1,79.8,332.1,79.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M333.6,80.6l0.4-0.8c0.3,0.2,0.8,0.4,1.3,0.4c0.5,0,0.7-0.1,0.7-0.3c0-0.6-2.3,0-2.3-1.5 c0-0.7,0.6-1.2,1.7-1.2c0.5,0,1.1,0.1,1.4,0.3l-0.4,0.8c-0.4-0.2-0.7-0.3-1.1-0.3c-0.5,0-0.7,0.2-0.7,0.4c0,0.6,2.3,0,2.3,1.5 c0,0.7-0.7,1.2-1.8,1.2C334.6,81.1,333.9,80.9,333.6,80.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M343,79.5c0,0.8-0.6,1.6-2,1.6c-0.7,0-1.4-0.2-1.9-0.5l0.4-0.9c0.4,0.3,0.9,0.4,1.4,0.4 c0.6,0,0.9-0.2,0.9-0.6c0-0.4-0.3-0.6-0.9-0.6h-0.5v-0.7l1-1.1h-2.1v-0.9h3.4v0.7l-1.1,1.3C342.6,78.2,343,78.8,343,79.5z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasetDiagram);
export default __webpack_public_path__ + "static/media/dataset-diagram.76bbf7cd195412d5ae016984d236e9df.svg";
export { ForwardRef as ReactComponent };